let csrfToken: string;

/**
 * Retrieves the CSRF token from the HTML document.
 *
 * @return {string} The CSRF token.
 */
export function getCsrfToken(): string {
    if (!csrfToken) {
        csrfToken = (document.getElementsByName("__RequestVerificationToken")[0] as HTMLInputElement)?.value || "";
    }
    return csrfToken;
}
